export default __webpack_public_path__ + "static/media/yogantar.83931a5d.png";